import styled from 'styled-components';
import ActionLink from 'components/ActionLink';
import { whitesmoke } from 'utils/style/colors';

export const Wrapper = styled('div')`
  background-color: ${whitesmoke};
  border-radius: 10px;
  padding: 0.5em;
  margin: 1em 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const InputsWrapper = styled('div')`
  display: flex;
  & > div {
    max-width: 10em;
    margin: 0 1em;
  }
`;

export const Action = styled(ActionLink)`
  margin: 0 0.5em;
`;
